var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-btn',{attrs:{"color":"success"},on:{"click":_vm.fetchAPI}},[_vm._v("Betaal")]),_vm._v(" "+_vm._s(_vm.response)+" "),_c('canvas',{attrs:{"id":"canvas"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }